export default "__VITE_ASSET__BaGCu87n__"